import { useMemo } from "react";

interface ViewType {
  name: string;
  path: string;
}

const useContentURL = (
  viewName: string | null,
  userViews: ViewType[],
  uuid?: string,
) => {
  const contentURL = useMemo(() => {
    if (userViews) {
      if (viewName) {
        const selectedView = userViews.find((v) => v.name === viewName);
        return selectedView?.path;
      } else {
        const defaultView = userViews[0];
        return defaultView?.path;
      }
    }
  }, [viewName, userViews, uuid]);

  return { contentURL };
};

export default useContentURL;
